import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { VerificationType } from '../app/VerificationType';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { setIsNewUser, setVerificationType } from '../store/app/action-creators';
import { useTrackSignupInitiated } from '../tracking/useTrackSignupInitiated';
import { useView } from '../views/useView';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
export const useLandingPage = stepKey => {
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    setData: setToken
  } = useSignupData(Data.Token);
  const dispatch = useDispatch();
  const {
    isAssignedToSpecificVariant: isAssignedToSpecificVariantACQ134
  } = useExperiment(ExperimentKeys.ACQ0134, TrackWhen.never);
  useEffect(() => {
    dispatch(setIsNewUser(true));
  }, [dispatch]);
  const isAssignedToAcq134VariantB = isAssignedToSpecificVariantACQ134(ExperimentParameterGroup.Variant_B);
  useTrackSignupInitiated(!isAssignedToAcq134VariantB);

  const chooseEmailSignUp = () => {
    setToken(null);
    dispatch(setVerificationType(VerificationType.EmailByCode));
    submit();
  };

  return {
    chooseEmailSignUp
  };
};